/**
 * Imports
*/
import './tpl.view.scss';

// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewDemo_ListItem extends Component {

  constructor(props) {
    super(props);
  }

  render()
  {
    const { video } = this.props;
    let { image, id, caption, post_type, post_code } = video;

    let { demoGridColHeight } = this.props.options;
    const styleGridImg = {
      height: demoGridColHeight + 'px',
    };
    
    return (
      <li
        data-key={ id }
        data-name={ caption }
        onClick={ (e) => { this.handleMenuClick( e, { videoid: video.id, image, post_type } ) } }
      >
        <div className={ `${alias}image` } style={ styleGridImg }>
          <div>
            { '' !== image ? <img src={ image } /> : '' }
          </div>
          { 'video' === post_type ? <i className="glyphter-instaberg-video"></i> : '' }
        </div>
      </li>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  handleMenuClick( event, pms )
  {
    event.preventDefault();
    this.props.onClickListItem( pms );
  }
}

class InstabergViewDemo extends Component {

  constructor(props) {
    super(props);
  }

  render() 
  {
    return ( this.PrintVideosList() );
  }

  PrintVideoSingleElement( video )
  {
    return (
      <InstabergViewDemo_ListItem
        video={ video }
        options={ this.props.options }
        onClickListItem={ (pms) => { this.props.onClickListItem( pms ) } }
      />
    );
  }

  PrintVideosList()
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;
    const demoGridCols = parseInt( this._get_option('demoGridCols') );

    if ( ! videos.length ) {
      return '';
    }

    const styleGrid = {
      'grid-column-gap': this._get_option('demoGridColGap') + 'px',
      'grid-row-gap': this._get_option('demoGridRowGap') + 'px',
    };

    const video_list = videos.map( video => {
      return ( this.PrintVideoSingleElement( video ) );
    });

    return (
      <React.Fragment>
        <ul
          className={ `${alias}videos-list ${alias}gridtpl ${alias}gridtpl-${demoGridCols}` }
          style={ styleGrid }
        >
          { video_list }
        </ul>
      </React.Fragment>
    );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

}
export { InstabergViewDemo };


// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/_demo/tpl.view.js